// src/AppAdmin.js
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Header from "./adminComponents/Header";
import BottomNav from "./adminComponents/BottomNav";
import Dashboard from "./adminPages/Dashboard";
import Shared from "./adminPages/Shared";
import ContactUs from "./adminPages/ContactUs";
import Profile from "./adminPages/Profile";
import config from "./config.json";

const AppAdmin = () => {
  const sessionUser = JSON.parse(localStorage.getItem("loggedInUser") || "null");
  const isDev =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

  if (!isDev && sessionUser?.email !== config.adminemail) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="mobile-app-shell admin-app-shell">
      <Header title="Admin" />
      <Routes>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="shared" element={<Shared />} />
        <Route path="contactus" element={<ContactUs />} />
        <Route path="profile" element={<Profile />} />
      </Routes>
      <BottomNav />
    </div>
  );
};

export default AppAdmin;
